var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserSrc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.70591 4C8.70591 3.7863 8.84172 3.59623 9.04388 3.52698C9.24605 3.45773 9.46987 3.52462 9.6009 3.69343L12.395 7.29343C12.535 7.47383 12.535 7.72617 12.395 7.90657L9.6009 11.5066C9.46987 11.6754 9.24605 11.7423 9.04388 11.673C8.84172 11.6038 8.70591 11.4137 8.70591 11.2V9.70651C6.63831 9.76191 5.65984 10.1623 5.176 10.5769C4.71128 10.9751 4.62729 11.4379 4.53244 11.9605C4.52458 12.0038 4.51664 12.0475 4.5084 12.0917C4.46212 12.3398 4.23822 12.5145 3.98633 12.4991C3.73444 12.4836 3.53353 12.2829 3.51785 12.0311C3.44889 10.9234 3.55115 9.30759 4.34029 7.95038C5.09982 6.64407 6.45838 5.64277 8.70591 5.51403V4ZM9.70591 9.7403L11.3671 7.6L9.70591 5.4597V6C9.70591 6.27614 9.48205 6.5 9.20591 6.5C6.98335 6.5 5.82536 7.3857 5.20478 8.45302C4.98308 8.83431 4.82493 9.24786 4.71538 9.66789C5.54037 9.0703 6.90951 8.7 9.20591 8.7C9.48205 8.7 9.70591 8.92386 9.70591 9.2V9.7403Z",
    fill: "#20127F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSrc);
export default __webpack_public_path__ + "static/media/user-src.a8d40ed5b56741495aa030bd977e828d.svg";
export { ForwardRef as ReactComponent };